export const unix2date = function (unix) {
  if (unix > 9000000000) {
    unix = parseInt(unix / 1000)
  }
  // Date.parse(new Date())/1000 得到时间
  // 传入时间 var unix = 1353033300;
  var date = new Date(parseInt(unix) * 1000)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 // js从0开始取
  if (month < 10) {
    month = '0' + month
  }
  var date1 = date.getDate()
  if (date1 < 10) {
    date1 = '0' + date1
  }
  var hour = date.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var second = date.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  return month + '-' + date1 + ' ' + hour + ':' + minutes
}

export const unix2date3 = function (unix) {
  if (unix > 9000000000) {
    unix = parseInt(unix / 1000)
  }
  // Date.parse(new Date())/1000 得到时间
  // 传入时间 var unix = 1353033300;
  var date = new Date(parseInt(unix) * 1000)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 // js从0开始取
  if (month < 10) {
    month = '0' + month
  }
  var date1 = date.getDate()
  if (date1 < 10) {
    date1 = '0' + date1
  }
  var hour = date.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var second = date.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  return month + '-' + date1
}

export const unix2date4 = function (unix, tr) {
  if (unix == 0) {
    return ''
  }
  if (unix > 9000000000) {
    unix = parseInt(unix / 1000)
  }
  // Date.parse(new Date())/1000 得到时间
  // 传入时间 var unix = 1353033300;
  var date = new Date(parseInt(unix) * 1000)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 // js从0开始取
  if (month < 10) {
    month = '0' + month
  }
  var date1 = date.getDate()
  if (date1 < 10) {
    date1 = '0' + date1
  }
  var hour = date.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var second = date.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  if (tr == true) {
    return date1 + '.' + month
  }
  return month + '.' + date1
}

export const unix2date5 = function (unix, tr) {
  if (unix == 0) {
    return ''
  }
  if (unix > 9000000000) {
    unix = parseInt(unix / 1000)
  }
  // Date.parse(new Date())/1000 得到时间
  // 传入时间 var unix = 1353033300;
  var date = new Date(parseInt(unix) * 1000)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 // js从0开始取
  if (month < 10) {
    month = '0' + month
  }
  var date1 = date.getDate()
  if (date1 < 10) {
    date1 = '0' + date1
  }
  var hour = date.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var second = date.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  if (tr == true) {
    return date1 + '-' + month + ' ' + hour + ':' + minutes
  }
  return month + '-' + date1 + ' ' + hour + ':' + minutes
}
export const unix2date6 = function (unix, tr) {
  if (unix == 0) {
    return ''
  }
  if (unix > 9000000000) {
    unix = parseInt(unix / 1000)
  }
  // Date.parse(new Date())/1000 得到时间
  // 传入时间 var unix = 1353033300;
  var date = new Date(parseInt(unix) * 1000)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 // js从0开始取
  if (month < 10) {
    month = '0' + month
  }
  var date1 = date.getDate()
  if (date1 < 10) {
    date1 = '0' + date1
  }
  var hour = date.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var second = date.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  if (tr == true) {
    return year + '-' + date1 + '-' + month + ' ' + hour + ':' + minutes
  }
  return year + '-' + month + '-' + date1 + ' ' + hour + ':' + minutes
}
export const unix2date7 = function (unix, tr) {
  if (unix == 0) {
    return ''
  }
  if (unix > 9000000000) {
    unix = parseInt(unix / 1000)
  }
  // Date.parse(new Date())/1000 得到时间
  // 传入时间 var unix = 1353033300;
  var date = new Date(parseInt(unix) * 1000)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 // js从0开始取
  if (month < 10) {
    month = '0' + month
  }
  var date1 = date.getDate()
  if (date1 < 10) {
    date1 = '0' + date1
  }
  var hour = date.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var second = date.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  if (tr == true) {
    return year + '-' + date1 + '-' + month + ' ' + hour + ':' + minutes
  }
  return month + '-' + date1 + ' ' + hour + ':' + minutes
}

export const unix2date8 = function (unix, tr) {
  if (unix == 0) {
    return ''
  }
  if (unix > 9000000000) {
    unix = parseInt(unix / 1000)
  }
  // Date.parse(new Date())/1000 得到时间
  // 传入时间 var unix = 1353033300;
  var date = new Date(parseInt(unix) * 1000)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 // js从0开始取
  if (month < 10) {
    month = '0' + month
  }
  var date1 = date.getDate()
  if (date1 < 10) {
    date1 = '0' + date1
  }
  var hour = date.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var second = date.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  return year + '-' + month + '-' + date1 + ' ' + hour + ':' + minutes + ':' + second
}

export const getDateObj = function (unix, tr) {
  if (unix == 0) {
    return ''
  }
  if (unix > 9000000000) {
    unix = parseInt(unix / 1000)
  }
  var date = new Date(parseInt(unix) * 1000)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  var date1 = date.getDate()
  if (date1 < 10) {
    date1 = '0' + date1
  }
  var hour = date.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var second = date.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  if (tr == true) {
    return {
      year,
      month,
      date1,
      hour,
      minutes
    }
  }
  return {
    year,
    month,
    date1,
    hour,
    minutes
  }
}

//仅给斋月专用
export const unix2date2 = function (unix) {
  if (unix > 9000000000) {
    unix = parseInt(unix / 1000)
  }

  // Date.parse(new Date())/1000 得到时间
  // 传入时间 var unix = 1353033300;
  var date = new Date(parseInt(unix + (480 - parseInt(new Date().getTimezoneOffset())) * 60) * 1000)

  var year = date.getFullYear()
  var month = date.getMonth() + 1 // js从0开始取
  if (month < 10) {
    month = '0' + month
  }
  var date1 = date.getDate()
  if (date1 < 10) {
    date1 = '0' + date1
  }
  var hour = date.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  var minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  var second = date.getSeconds()
  if (second < 10) {
    second = '0' + second
  }
  // console.log(parseInt(unix) * 1000, month + '-' + date1, zonets())
  return month + '-' + date1
}

export const zonets = function () {
  let tz = parseInt(new Date().getTimezoneOffset())
  tz = 480 + tz
  return tz * 60
}

export const todayts = function () {
  var data = new Date()
  data.setHours(0)
  data.setSeconds(0)
  data.setMinutes(0)
  return Math.floor(data.getTime() / 1000) - zonets() + 18000
}

//不分时区
export const todayts2 = function () {
  var data = new Date()
  data.setHours(0)
  data.setSeconds(0)
  data.setMinutes(0)
  return Math.floor(data.getTime() / 1000) - zonets()
}

export const nowtime = function () {
  var data = new Date()
  return Math.floor(data.getTime() / 1000) - zonets()
}

export const lastmonthts = function () {
  var data = new Date()
  if (data.getMonth() == 1) {
    data.setMonth(12)
    data.setFullYear(data.getFullYear() - 1)
  } else {
    data.setMonth(data.getMonth() - 1)
  }
  data.setDate(1)
  data.setHours(0)
  data.setSeconds(0)
  data.setMinutes(0)
  return Math.floor(data.getTime() / 1000) - zonets() + 18000
}

export const lastmonthts2 = function () {
  var data = new Date()
  if (data.getMonth() == 1) {
    data.setMonth(12)
    data.setFullYear(data.getFullYear() - 1)
  } else {
    data.setMonth(data.getMonth() - 1)
  }
  data.setDate(1)
  data.setHours(0)
  data.setSeconds(0)
  data.setMinutes(0)
  return Math.floor(data.getTime() / 1000) - zonets()
}

export const thismonthts = function () {
  var data = new Date()
  data.setDate(1)
  data.setHours(0)
  data.setSeconds(0)
  data.setMinutes(0)
  return Math.floor(data.getTime() / 1000) - zonets() + 18000
}

export const thismonthts2 = function () {
  var data = new Date()
  data.setDate(1)
  data.setHours(0)
  data.setSeconds(0)
  data.setMinutes(0)
  return Math.floor(data.getTime() / 1000) - zonets()
}

export const nextmonthts = function () {
  var data = new Date()
  if (data.getMonth() == 12) {
    data.setMonth(1)
  } else {
    data.setMonth(data.getMonth() + 1)
  }
  data.setDate(1)
  data.setHours(0)
  data.setSeconds(0)
  data.setMinutes(0)
  return Math.floor(data.getTime() / 1000) - zonets() + 18000
}

export const nextmonthts2 = function () {
  var data = new Date()
  if (data.getMonth() == 12) {
    data.setMonth(1)
  } else {
    data.setMonth(data.getMonth() + 1)
  }
  data.setDate(1)
  data.setHours(0)
  data.setSeconds(0)
  data.setMinutes(0)
  return Math.floor(data.getTime() / 1000) - zonets()
}



// WEBPACK FOOTER //
// src/helper/time.js